import React from 'react';
import { Switch as ChakraSwitch, SwitchProps as ChakraSwitchProps } from '@chakra-ui/react';

export function Switch(props: ChakraSwitchProps) {
  return <ChakraSwitch {...props} />;
}
